import {Component, OnDestroy, OnInit, inject, HostListener} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/login/data-access/auth.service';
import {SystemManagementService} from "../../../admin/data-access/system-management.service";
import {Message} from "../../../admin/feature/system-management/announcement-list/announcement-list.component";
import {faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import {Course} from "../../../admin/data-access/course.model";
import {StudentExam} from "../studentDashboard/studentDashboard.component";
import {StatusFormatterPipe} from "../studentDashboard/statusFormatter.pipe";
import {getDaysRemaining} from "../../../shared/utils/getDaysRemaining";

@Component({
    selector: 'studentClassroomDashboard',
    templateUrl: './studentClassroomDashboard.component.html',
    providers: [StatusFormatterPipe],
    styleUrls: ['../studentDashboard/studentDashboard.component.css'],
    standalone: false
})
export class StudentClassroomDashboardComponent implements OnInit, OnDestroy {
  messageBoxStyle = `background: linear-gradient(to left, transparent 10%, ${localStorage.getItem('primaryColor')}); border-radius: 8px; color: white; margin-top: 20px;`
  systemService = inject(SystemManagementService)
  studentMessages: Message[] = []
  studentMessageIter = 0
  authService = inject(AuthService);
  orgID: number[] = []
  examListResponse: StudentExam[] = []
  upcomingAssessments: StudentExam[] = []
  optionalListResponse: Course[] = []
  isLoading: boolean = true
  isLoadingList: boolean = true
  isLoadingListOptional: boolean = true
  isScreenSmall = false
  statusFormatterPipe = inject(StatusFormatterPipe);
  router = inject(Router);

  userPerms: Subscription = this.authService.userDashboard$.subscribe((user) => {

    // TODO will need to change the get my exams to the classroom version
    if(user.success) {
      // TODO need to update get my classroom endpoint to have date time constraints/sort by due_time. Will use for upcoming assessments and calendar
      this.authService.getMyClassroomAssessments(0, 5, "", true, true, true, true).subscribe((response) => {
        if(response.success) {
          this.upcomingAssessments = response.result;
        }
      })
      for(let perm of user.result) {
        // TODO push in a array to handle multiple orgs
        if(perm.organization_id != null && !this.orgID.includes(perm.organization_id) && perm.ui === 'ExamTake')
          this.orgID.push(perm.organization_id)
      }
      if(this.orgID.length > 0) {
        for(let org of this.orgID) {
          this.authService.getMyExams(org).subscribe((response) => {
            if(response.success) {
              this.examListResponse = this.examListResponse.concat(response.result)
            } else {
              // TODO handle error
            }
          })
          this.authService.getOptionalExams(org).subscribe((response) => {
            if(response.success) {
              this.optionalListResponse = response.result
            } else {
              // TODO handle error
            }
          })
        }
      }
    }
    this.isLoadingList = false
    this.isLoadingListOptional = false
  })

  @HostListener('window:resize')
  OnResize() {
    this.checkScreenSize()
  }

  checkScreenSize() {
    this.isScreenSmall = window.innerWidth <= 1025
  }

  startAssessment(exam_id: number) {
    this.router.navigate(['dashboard/assessment/take'], {queryParams: {id: exam_id}})
  }

  ngOnInit() {
    this.checkScreenSize()

    this.systemService.listAnnouncements('student').subscribe((response) => {
      if(response.success) {
        this.studentMessages = []
        for(let message of response.result) {
          if(message.dashboard === 'student' || message.dashboard === 'universal') {
            this.studentMessages.push(message)
          }
        }
      } else {
        this.studentMessages = []
      }
    })
  }

  ngOnDestroy() {}

  incrementMessages() {
    if(this.studentMessageIter < this.studentMessages.length)
      this.studentMessageIter++
  }

  decrementMessages() {
    if(this.studentMessageIter > 0)
      this.studentMessageIter--
  }

  protected readonly faChevronLeft = faChevronLeft;
  protected readonly faChevronRight = faChevronRight;
  protected readonly Math = Math;
  protected readonly getDaysRemaining = getDaysRemaining;
}
